import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Field, Form, Formik } from "formik";
import { toast } from "react-toastify";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Typography,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  Grid,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Paper,
  FormControlLabel,
  Switch,
  Divider,
  FormHelperText
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { useStyles } from "./GroupCampaignModalStyles";
import useGroupCampaign from "./useGroupCampaign";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";
// import MessageVariablesPicker from "../MessageVariablesPicker"; // Ya no se usa
import ConfirmationModal from "../ConfirmationModal";
// ✅ FASE 2: Componentes compartidos
import RecurrenceTab from "../SharedCampaignComponents/RecurrenceTab";
import IntervalTab from "../SharedCampaignComponents/IntervalTab";
// ✅ FASE 2: Validaciones de fecha
import moment from "moment-timezone";
import { getCampaignTimezoneSync } from "../../helpers/getCampaignTimezone";
import DateTimePickerWithTimezone from "../FormFields/DateTimePickerWithTimezone";


const GroupCampaignModal = ({
  open,
  onClose,
  campaignId,
  initialValues,
  onSave,
  campaignType = null, // 'UNICA' o 'RECURRENTE' - viene del botón dropdown
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const {
    attachment,
    attachmentFile,
    availableGroups,
    campaignMedia,
    companyId,
    configTab,
    confirmChangeRecurrenceTypeModalOpen,
    confirmChangeScheduledDateModalOpen,
    confirmDeleteAllSchedulesModalOpen,
    confirmDisableHourlyScheduleModalOpen,
    confirmDisableRecurrenceModalOpen,
    confirmModalOpen,
    copiedGroupsData,
    currentCampaignType,
    currentSchedule,
    datePastMessage,
    datePastModalOpen,
    editingScheduleIndex,
    endIndex,
    files,
    filteredGroups,
    formatFileSize,
    formatInvalidMessage,
    formatInvalidModalOpen,
    formikResetFormRef,
    formikSetFieldValueRef,
    groupPage,
    groupsPerPage,
    handleAttachmentClick,
    handleClose,
    handleConfirmAndSave,
    handleConfirmChangeRecurrenceType,
    handleConfirmDisableRecurrence,
    handleFileChange,
    handleNextPage,
    handlePrevPage,
    handleRecurrenceTypeChange,
    handleSave,
    hasInitialized,
    hourlyScheduleFileInput,
    hourlyScheduleMessageTab,
    hourlyScheduleModalOpen,
    hourlyScheduleTimeTouched,
    initialIsRecurring,
    initialRecurrenceInterval,
    initialRecurrenceType,
    initialState,
    initialTipo,
    isCompleted,
    isMounted,
    loading,
    loadingGroups,
    messageTab,
    missingScheduledDateModalOpen,
    paginatedGroups,
    pendingNewHour,
    pendingNewRecurrenceType,
    pendingOldHour,
    pendingOldRecurrenceType,
    pendingRecurrenceTypeChange,
    pendingSaveValues,
    pendingScheduledAt,
    pendingScheduledDateChange,
    pendingSchedulesCount,
    pendingSetFieldValue,
    pendingSubmit,
    processSave,
    saveCampaignRef,
    searchGroupTerm,
    selectedConnection,
    selectedGroups,
    setAttachment,
    setAvailableGroups,
    setCampaignMedia,
    setConfigTab,
    setConfirmChangeRecurrenceTypeModalOpen,
    setConfirmChangeScheduledDateModalOpen,
    setConfirmDeleteAllSchedulesModalOpen,
    setConfirmDisableHourlyScheduleModalOpen,
    setConfirmDisableRecurrenceModalOpen,
    setConfirmModalOpen,
    setCopiedGroupsData,
    setCurrentSchedule,
    setDatePastMessage,
    setDatePastModalOpen,
    setEditingScheduleIndex,
    setFiles,
    setFormatInvalidModalOpen,
    setGroupPage,
    setHasInitialized,
    setHourlyScheduleMessageTab,
    setHourlyScheduleModalOpen,
    setHourlyScheduleTimeTouched,
    setIsCompleted,
    setLoadingGroups,
    setMessageTab,
    setMissingScheduledDateModalOpen,
    setPendingNewHour,
    setPendingNewRecurrenceType,
    setPendingOldHour,
    setPendingOldRecurrenceType,
    setPendingRecurrenceTypeChange,
    setPendingSaveValues,
    setPendingScheduledAt,
    setPendingScheduledDateChange,
    setPendingSchedulesCount,
    setPendingSetFieldValue,
    setPendingSubmit,
    setSearchGroupTerm,
    setSelectedConnection,
    setSelectedGroups,
    setShortTimeMessage,
    setShortTimeModalOpen,
    setSizeExceededModalOpen,
    setWhatsapps,
    shortTimeMessage,
    shortTimeModalOpen,
    sizeExceededModalOpen,
    startIndex,
    toggleGroupSelection,
    totalPages,
    uniqueGroups,
    user,
    validateForm,
    whatsapps,
  } = useGroupCampaign({ open, onClose, campaignId, initialValues, onSave, campaignType });

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" scroll="paper">
        <DialogTitle id="form-dialog-title">
          {campaignId 
            ? (currentCampaignType === 'RECURRENTE' ? "Editar Campaña RECURRENTE" : "Editar Campaña ÚNICA")
            : (currentCampaignType === 'RECURRENTE' ? "Nueva Campaña RECURRENTE" : "Nueva Campaña ÚNICA")
          }
        </DialogTitle>
        <Formik
          initialValues={{
            ...initialState,
            // ✅ CORRECCIÓN CRÍTICA: Si campaignType es 'RECURRENTE', forzar isRecurring a true
            // Esto asegura que aunque initialValues tenga isRecurring: false, se use true para RECURRENTE
            isRecurring: campaignType === 'RECURRENTE' ? true : (campaignId && initialValues?.isRecurring !== undefined ? initialValues.isRecurring : initialState.isRecurring),
            // ✅ Sobrescribir solo campos de recurrencia si hay initialValues (edición)
            ...(campaignId && initialValues ? {
              recurrenceType: initialValues.recurrenceType || "",
              recurrenceInterval: initialValues.recurrenceInterval || "",
              recurrenceDaysOfWeek: initialValues.recurrenceDaysOfWeek || "",
              recurrenceDayOfMonth: initialValues.recurrenceDayOfMonth || "",
              recurrenceEndDate: initialValues.recurrenceEndDate || "",
              maxExecutions: initialValues.maxExecutions || "",
              useHourlySchedule: initialValues.useHourlySchedule || false,
              recurrenceHourlySchedules: initialValues.recurrenceHourlySchedules || [],
            } : {}),
          }}
          enableReinitialize={true}
          validate={validateForm}
          onSubmit={async (values, actions) => {
            // ✅ CORRECCIÓN: Marcar todos los campos con errores como "touched" para mostrar errores visualmente
            const validationErrors = validateForm(values);
            if (Object.keys(validationErrors).length > 0) {
              // ✅ CORRECCIÓN: Establecer errores primero
              actions.setErrors(validationErrors);
              
              // ✅ CORRECCIÓN: Crear objeto touchedFields completo
              const touchedFields = {};
              Object.keys(validationErrors).forEach(fieldName => {
                touchedFields[fieldName] = true;
              });
              
              // ✅ CORRECCIÓN: Usar setTouched con el objeto completo - esto actualiza el estado de Formik inmediatamente
              actions.setTouched(touchedFields);
              
              // ✅ CORRECCIÓN: Cambiar a la pestaña que contiene el primer campo con error
              // Orden de pestañas: 0=MENSAJE, 1=INTERVALO, 2=RECURRENCIA (para RECURRENTE)
              if (validationErrors.name || validationErrors.selectedGroups || validationErrors.scheduledDate || validationErrors.whatsappId) {
                // Errores en campos globales - no cambiar de pestaña (ya están visibles)
              } else if (validationErrors.message1 || validationErrors.message2 || validationErrors.message3 || validationErrors.message4 || validationErrors.message5) {
                setConfigTab(0); // Pestaña MENSAJE
              } else if (validationErrors.messageInterval || validationErrors.longerIntervalAfter || validationErrors.greaterInterval) {
                setConfigTab(1); // Pestaña INTERVALO
              } else if (validationErrors.recurrenceType || validationErrors.recurrenceInterval || validationErrors.recurrenceDaysOfWeek || validationErrors.recurrenceDayOfMonth) {
                setConfigTab(2); // Pestaña RECURRENCIA (solo para RECURRENTE)
              }
              
              // No continuar con el submit si hay errores
              actions.setSubmitting(false);
              return;
            }
            
            try {
              await handleSave(values, actions.setSubmitting);
            } catch (error) {
              console.error('[GroupCampaignModal] Error en onSubmit:', error);
            } finally {
              actions.setSubmitting(false);
            }
          }}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({ values, errors, touched, isSubmitting, setFieldValue, resetForm }) => {
            // ✅ NUEVO (09/12/2025): Guardar setFieldValue en ref para acceso desde modales
            // ✅ CORRECCIÓN: Actualizar ref directamente - esto NO causa re-renders
            formikSetFieldValueRef.current = setFieldValue;
            // ✅ CORRECCIÓN CRÍTICA: Guardar resetForm en ref para resetear formulario al cerrar
            formikResetFormRef.current = resetForm;
            
            // ✅ CORRECCIÓN: Mover lógica de recurrenceInterval a useEffect para evitar setState durante render
            // Esta lógica se maneja en un useEffect separado (ver más abajo)
            // ✅ NUEVO (09/12/2025): Función para calcular hora por defecto (+5 minutos)
            const calculateDefaultHour = () => {
              if (!values.scheduledDate) return null;
              
              try {
                // Extraer hora de scheduledDate
                const scheduledDateObj = new Date(values.scheduledDate);
                const scheduledHour = scheduledDateObj.getHours();
                const scheduledMinute = scheduledDateObj.getMinutes();
                
                // Obtener último horario configurado (si existe)
                let lastHour = scheduledHour;
                let lastMinute = scheduledMinute;
                
                if (values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length > 0) {
                  // Ordenar horarios y obtener el último
                  const sortedSchedules = [...values.recurrenceHourlySchedules].sort((a, b) => {
                    const [hA, mA] = a.time.split(':').map(Number);
                    const [hB, mB] = b.time.split(':').map(Number);
                    if (hA !== hB) return hA - hB;
                    return mA - mB;
                  });
                  
                  const lastSchedule = sortedSchedules[sortedSchedules.length - 1];
                  if (lastSchedule && lastSchedule.time) {
                    [lastHour, lastMinute] = lastSchedule.time.split(':').map(Number);
                  }
                }
                
                // Comparar y usar el mayor (hora maestra o último horario)
                let baseHour = scheduledHour;
                let baseMinute = scheduledMinute;
                
                if (lastHour > scheduledHour || (lastHour === scheduledHour && lastMinute > scheduledMinute)) {
                  baseHour = lastHour;
                  baseMinute = lastMinute;
                }
                
                // Agregar 5 minutos
                let newMinute = baseMinute + 5;
                let newHour = baseHour;
                
                if (newMinute >= 60) {
                  newMinute = newMinute - 60;
                  newHour = newHour + 1;
                }
                
                if (newHour >= 24) {
                  newHour = 0;
                }
                
                // Formatear a HH:mm
                return `${String(newHour).padStart(2, '0')}:${String(newMinute).padStart(2, '0')}`;
              } catch (error) {
                console.warn("Error calculando hora por defecto:", error);
                return null;
              }
            };
            
            // ✅ NUEVO (09/12/2025): Función para obtener hora mínima permitida
            const getMinimumAllowedHour = () => {
              if (!values.scheduledDate) return null;
              
              try {
                const scheduledDateObj = new Date(values.scheduledDate);
                const scheduledHour = scheduledDateObj.getHours();
                const scheduledMinute = scheduledDateObj.getMinutes();
                
                let lastHour = scheduledHour;
                let lastMinute = scheduledMinute;
                
                if (values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length > 0) {
                  const sortedSchedules = [...values.recurrenceHourlySchedules].sort((a, b) => {
                    const [hA, mA] = a.time.split(':').map(Number);
                    const [hB, mB] = b.time.split(':').map(Number);
                    if (hA !== hB) return hA - hB;
                    return mA - mB;
                  });
                  
                  const lastSchedule = sortedSchedules[sortedSchedules.length - 1];
                  if (lastSchedule && lastSchedule.time) {
                    [lastHour, lastMinute] = lastSchedule.time.split(':').map(Number);
                  }
                }
                
                let baseHour = scheduledHour;
                let baseMinute = scheduledMinute;
                
                if (lastHour > scheduledHour || (lastHour === scheduledHour && lastMinute > scheduledMinute)) {
                  baseHour = lastHour;
                  baseMinute = lastMinute;
                }
                
                // Agregar 1 minuto para obtener la mínima permitida
                let newMinute = baseMinute + 1;
                let newHour = baseHour;
                
                if (newMinute >= 60) {
                  newMinute = newMinute - 60;
                  newHour = newHour + 1;
                }
                
                if (newHour >= 24) {
                  newHour = 0;
                }
                
                return {
                  hour: `${String(newHour).padStart(2, '0')}:${String(newMinute).padStart(2, '0')}`,
                  context: lastHour !== scheduledHour || lastMinute !== scheduledMinute 
                    ? `último horario: ${String(baseHour).padStart(2, '0')}:${String(baseMinute).padStart(2, '0')} + 5 minutos`
                    : `hora maestra: ${String(scheduledHour).padStart(2, '0')}:${String(scheduledMinute).padStart(2, '0')} + 5 minutos`
                };
              } catch (error) {
                console.warn("Error obteniendo hora mínima:", error);
                return null;
              }
            };
            
            // ✅ NUEVO (08/12/2025): Funciones para manejar modal de horarios (dentro de Formik render)
            const handleOpenHourlyScheduleModal = (index = null) => {
              // ✅ NUEVA VALIDACIÓN (10/12/2025): Si es nuevo horario, verificar scheduledDate
              if (index === null) {
                // Es un nuevo horario (no edición)
                if (!values.scheduledDate || values.scheduledDate.trim() === "") {
                  // Mostrar modal de error
                  setMissingScheduledDateModalOpen(true);
                  return; // No abrir el modal de horario
                }
              }
              
              if (index !== null) {
                // Editar horario existente
                const schedule = values.recurrenceHourlySchedules[index];
                setCurrentSchedule({
                  time: schedule.time || "",
                  message1: schedule.message1 || "",
                  message2: schedule.message2 || "",
                  message3: schedule.message3 || "",
                  message4: schedule.message4 || "",
                  message5: schedule.message5 || "",
                  mediaPath: schedule.mediaPath || null,
                  mediaName: schedule.mediaName || null
                });
                setEditingScheduleIndex(index);
              } else {
                // ✅ NUEVO (09/12/2025): Nuevo horario - calcular hora por defecto
                const defaultHour = calculateDefaultHour();
                setCurrentSchedule({
                  time: defaultHour || "",
                  message1: "",
                  message2: "",
                  message3: "",
                  message4: "",
                  message5: "",
                  mediaPath: null,
                  mediaName: null,
                  mediaFile: null
                });
                setEditingScheduleIndex(null);
              }
              setHourlyScheduleTimeTouched(false); // ✅ Resetear estado "touched" al abrir modal
              setHourlyScheduleModalOpen(true);
            };

            const handleCloseHourlyScheduleModal = () => {
              setHourlyScheduleModalOpen(false);
              setEditingScheduleIndex(null);
              setHourlyScheduleMessageTab(0);
              setHourlyScheduleTimeTouched(false); // ✅ Resetear estado "touched" al cerrar
              setCurrentSchedule({
                time: "",
                message1: "",
                message2: "",
                message3: "",
                message4: "",
                message5: "",
                mediaPath: null,
                mediaName: null,
                mediaFile: null
              });
            };

            const handleSaveHourlySchedule = () => {
              // Validar horario
              if (!currentSchedule.time || !/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/.test(currentSchedule.time)) {
                toast.error("Debe ingresar una hora válida en formato HH:mm (ej: 09:30)");
                return;
              }
              if (!currentSchedule.message1 || currentSchedule.message1.trim() === "") {
                toast.error("El Mensaje 1 es obligatorio");
                return;
              }

              const schedules = values.recurrenceHourlySchedules || [];
              
              // ✅ NUEVO (09/12/2025): Validar conflicto con scheduledDate
              if (values.scheduledDate) {
                try {
                  const scheduledDateObj = new Date(values.scheduledDate);
                  const scheduledHour = String(scheduledDateObj.getHours()).padStart(2, '0') + ':' + String(scheduledDateObj.getMinutes()).padStart(2, '0');
                  
                  if (currentSchedule.time === scheduledHour) {
                    toast.error(
                      `No puede configurar un horario que coincida con la hora programada principal (${scheduledHour}). ` +
                      `La hora principal siempre usa los mensajes maestros. Por favor, cambie el horario configurado.`
                    );
                    return;
                  }
                  
                  // ✅ NUEVO (09/12/2025): Validar que horario sea posterior a scheduledDate
                  if (currentSchedule.time <= scheduledHour) {
                    toast.error(
                      `El horario (${currentSchedule.time}) no puede ser anterior o igual a la hora programada principal (${scheduledHour}). ` +
                      `La hora principal siempre se ejecuta primero. Por favor, configure horarios posteriores a ${scheduledHour}.`
                    );
                    return;
                  }
                } catch (error) {
                  console.warn("Error validando conflicto con scheduledDate:", error);
                }
              }
              
              // Verificar duplicado (excepto si estamos editando el mismo)
              const duplicateIndex = schedules.findIndex((s, i) => s.time === currentSchedule.time && i !== editingScheduleIndex);
              if (duplicateIndex !== -1) {
                toast.error(`Ya existe un horario configurado para las ${currentSchedule.time}`);
                return;
              }

              // Verificar límite de 24 horarios
              if (editingScheduleIndex === null && schedules.length >= 24) {
                toast.error("No se pueden configurar más de 24 horarios por día");
                return;
              }

              const newSchedule = {
                time: currentSchedule.time,
                message1: currentSchedule.message1.trim(),
                message2: currentSchedule.message2 ? currentSchedule.message2.trim() : "",
                message3: currentSchedule.message3 ? currentSchedule.message3.trim() : "",
                message4: currentSchedule.message4 ? currentSchedule.message4.trim() : "",
                message5: currentSchedule.message5 ? currentSchedule.message5.trim() : "",
                mediaPath: currentSchedule.mediaPath || null,
                mediaName: currentSchedule.mediaName || null,
                // ✅ NUEVO (10/01/2026): Guardar mediaFile para subirlo antes de guardar la campaña
                mediaFile: currentSchedule.mediaFile || null
              };

              if (editingScheduleIndex !== null) {
                // Editar horario existente
                const newSchedules = [...schedules];
                newSchedules[editingScheduleIndex] = newSchedule;
                setFieldValue('recurrenceHourlySchedules', newSchedules);
              } else {
                // Agregar nuevo horario
                setFieldValue('recurrenceHourlySchedules', [...schedules, newSchedule]);
              }

              handleCloseHourlyScheduleModal();
              toast.success(editingScheduleIndex !== null ? "Horario actualizado correctamente" : "Horario agregado correctamente");
            };
            
            return (
              <>
                <Form>
                  <DialogContent dividers className={classes.dialogContent}>
                    {/* ✅ Mensaje de alerta si la campaña ya fue completada */}
                    {isCompleted && (
                      <Paper style={{ 
                        padding: 16, 
                        marginBottom: 16, 
                        backgroundColor: '#e3f2fd',
                        borderLeft: '4px solid #2196f3'
                      }}>
                        <Typography variant="body2" style={{ color: '#1976d2', fontWeight: 'bold' }}>
                          <span role="img" aria-label="Advertencia">⚠️</span> Esta campaña ya fue completada y enviada. Los campos están en modo solo lectura.
                        </Typography>
                      </Paper>
                    )}
                    
                    <Grid spacing={2} container>
                  {/* Nombre y Conexión en una fila */}
                  <Grid xs={12} md={6} item>
                    <TextField
                      label={<span><span role="img" aria-label="Nombre">📝</span> Nombre</span>}
                      name="name"
                      value={values.name || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        // ✅ Limitar a 50 caracteres
                        if (newValue.length <= 50) {
                          setFieldValue('name', newValue);
                        }
                      }}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.textField}
                      disabled={isCompleted} // ✅ Deshabilitar si ya fue completada
                      error={Boolean((touched.name && errors.name) || (values.name && values.name.length > 50))}
                      helperText={
                        values.name && values.name.length > 50
                          ? "Solo se permiten 50 caracteres"
                          : (touched.name && errors.name ? errors.name : "")
                      }
                      inputProps={{
                        maxLength: 50,
                        minLength: 3
                      }}
                      style={{
                        borderColor: values.name && values.name.length > 50 ? '#f44336' : undefined
                      }}
                    />
                  </Grid>

                  <Grid xs={12} md={6} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={`${classes.formControl} ${classes.selectField}`}
                      error={Boolean(touched.whatsappId && errors.whatsappId)}
                    >
                      {/* ✅ CORRECCIÓN: Eliminado InputLabel que se superponía con renderValue */}
                      <Select
                        value={whatsapps && whatsapps.length > 0 && whatsapps.some(w => w.id.toString() === String(values.whatsappId || "")) ? (values.whatsappId || "") : ""}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setFieldValue('whatsappId', selectedValue);
                          // ✅ Actualizar selectedConnection para el filtro de grupos
                          if (selectedValue === "" || selectedValue === "all") {
                            setSelectedConnection("all");
                          } else {
                            setSelectedConnection(selectedValue);
                          }
                          setSearchGroupTerm("");
                          setGroupPage(1);
                        }}
                        disabled={isCompleted} // ✅ Deshabilitar si ya fue completada
                        displayEmpty
                        renderValue={() => {
                          if (!values.whatsappId || values.whatsappId === "") {
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                                <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                <span>Seleccione una conexión *</span>
                              </div>
                            );
                          }
                          const whatsapp = whatsapps.find(w => w.id === values.whatsappId);
                          if (!whatsapp) {
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                                <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                <span>Seleccione una conexión *</span>
                              </div>
                            );
                          }
                          return (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                  {whatsapp.name || `Conexión ${whatsapp.id}`}
                                </span>
                                <span style={{ fontSize: '12px', color: '#666' }}>
                                  {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                                   whatsapp.name ? whatsapp.name : 
                                   `Conexión ${whatsapp.id}`}
                                </span>
                              </div>
                            </div>
                          );
                        }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                      >
                        {whatsapps && Array.isArray(whatsapps) && whatsapps.length > 0 && whatsapps.map((whatsapp) => (
                          <MenuItem dense key={whatsapp.id} value={whatsapp.id}>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                              <span style={{ marginRight: '8px', fontSize: '16px' }} role="img" aria-label="WhatsApp">📱</span>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {whatsapp.name || `Conexión ${whatsapp.id}`}
                                  </span>
                                  <span 
                                    style={{ 
                                      fontSize: '10px', 
                                      padding: '2px 6px', 
                                      borderRadius: '10px',
                                      backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    {whatsapp.status}
                                  </span>
                                </div>
                                <span style={{ fontSize: '12px', color: '#666' }}>
                                  {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                                   whatsapp.name ? whatsapp.name : 
                                   `Conexión ${whatsapp.id}`}
                                </span>
                              </div>
                            </div>
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.whatsappId && errors.whatsappId && (
                        <FormHelperText>{errors.whatsappId}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {/* ✅ FASE 2: CAMPOS GLOBALES (fuera de pestañas) - Lista de Grupos WA */}
                  <Grid xs={12} item>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                      <Box display="flex" alignItems="center">
                        <Typography variant="body2" color="textSecondary" gutterBottom={false}>
                          <span role="img" aria-label="Grupos">👥</span> Lista de Grupos WA *
                        </Typography>
                        {loadingGroups && (
                          <CircularProgress size={16} style={{ marginLeft: 8 }} />
                        )}
                      </Box>
                      {/* ✅ NUEVO (09/12/2025): Botones de selección masiva */}
                      {!loadingGroups && availableGroups.length > 0 && (
                        <Box display="flex" gap={1}>
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                              const allGroupIds = availableGroups.map(g => g.groupId);
                              setFieldValue('selectedGroups', allGroupIds);
                              setSelectedGroups(allGroupIds);
                              toast.success(`${allGroupIds.length} grupos seleccionados`);
                            }}
                            disabled={isCompleted}
                            style={{ fontSize: '0.75rem', padding: '4px 8px' }}
                          >
                            <span role="img" aria-label="Seleccionar todo">✓</span> Todos
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            color="secondary"
                            onClick={() => {
                              setFieldValue('selectedGroups', []);
                              setSelectedGroups([]);
                              toast.success("Todos los grupos fueron deseleccionados");
                            }}
                            disabled={isCompleted}
                            style={{ fontSize: '0.75rem', padding: '4px 8px' }}
                          >
                            <span role="img" aria-label="Deseleccionar todo">✗</span> Ninguna
                          </Button>
                        </Box>
                      )}
                    </Box>
                    
                    <TextField
                      placeholder="Buscar grupos..."
                      size="small"
                      value={searchGroupTerm}
                      onChange={(e) => {
                        setSearchGroupTerm(e.target.value);
                        setGroupPage(1);
                      }}
                      disabled={loadingGroups || isCompleted}
                      className={classes.textField}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      margin="dense"
                    />
                    
                    {/* Contador */}
                    <Typography 
                      variant="body2" 
                      gutterBottom 
                      style={{ 
                        fontWeight: 'bold', 
                        marginTop: 8,
                        color: (touched.selectedGroups && errors.selectedGroups) ? '#d32f2f' : 'primary'
                      }}
                    >
                      <span role="img" aria-label="Seleccionados">✅</span> {selectedGroups.length} {selectedGroups.length === 1 ? 'grupo seleccionado' : 'grupos seleccionados'}
                    </Typography>
                    {/* ✅ Mostrar error si no hay grupos seleccionados */}
                    {touched.selectedGroups && errors.selectedGroups && (
                      <Typography variant="caption" color="error" style={{ display: 'block', marginTop: 4, marginLeft: 14 }}>
                        {errors.selectedGroups}
                      </Typography>
                    )}

                    {/* Vista previa de seleccionados (máximo 5) */}
                    {selectedGroups.length > 0 && (
                      <Box mb={2}>
                        <Typography variant="caption" color="textSecondary" gutterBottom>
                          Vista previa ({selectedGroups.length}):
                        </Typography>
                        <Box display="flex" flexWrap="wrap" gap={1}>
                          {[...new Set(selectedGroups)].slice(0, 5).map((groupId, index) => {
                            const group = availableGroups.find(g => g.groupId === groupId) || 
                                         copiedGroupsData.find(c => c.groupId === groupId) ||
                                         copiedGroupsData.find(c => c.groupDetails?.groupId === groupId);
                            
                            const groupName = group?.name || group?.groupDetails?.name || `Grupo ${groupId}`;
                            
                            return (
                              <Chip
                                key={`${groupId}-${index}`}
                                label={groupName}
                                onDelete={() => toggleGroupSelection(groupId)}
                                color="primary"
                                size="small"
                              />
                            );
                          })}
                          {selectedGroups.length > 5 && (
                            <Chip
                              label={`+${selectedGroups.length - 5} más`}
                              color="primary"
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </Box>
                      </Box>
                    )}

                    {/* Lista de grupos con checkboxes */}
                    <Box className={classes.groupsContainer}>
                      {loadingGroups ? (
                        <Box display="flex" justifyContent="center" alignItems="center" style={{ padding: 32 }}>
                          <CircularProgress />
                          <Typography variant="body2" color="textSecondary" style={{ marginLeft: 16 }}>
                            Cargando grupos...
                          </Typography>
                        </Box>
                      ) : paginatedGroups.length > 0 ? (
                        <>
                          <List dense>
                            {paginatedGroups.map((group) => {
                              const isSelected = selectedGroups.includes(group.groupId);
                              return (
                                <ListItem
                                  key={group.groupId}
                                  button
                                  onClick={() => !isCompleted && toggleGroupSelection(group.groupId)}
                                  selected={isSelected}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      checked={isSelected}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        if (!isCompleted) {
                                          toggleGroupSelection(group.groupId);
                                        }
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                      disabled={isCompleted}
                                    />
                                  </ListItemIcon>
                                  <ListItemText 
                                    primary={group.name} 
                                    secondary={group.groupId}
                                    primaryTypographyProps={{
                                      style: { 
                                        fontWeight: isSelected ? 'bold' : 'normal',
                                        color: isSelected ? '#1976d2' : 'inherit'
                                      }
                                    }}
                                  />
                                </ListItem>
                              );
                            })}
                          </List>
                          {totalPages > 1 && (
                            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                              <IconButton onClick={handlePrevPage} disabled={groupPage === 1 || isCompleted} size="small">
                                <ChevronLeftIcon />
                              </IconButton>
                              <Typography variant="body2">
                                Página {groupPage} de {totalPages}
                              </Typography>
                              <IconButton onClick={handleNextPage} disabled={groupPage === totalPages || isCompleted} size="small">
                                <ChevronRightIcon />
                              </IconButton>
                            </Box>
                          )}
                        </>
                      ) : (
                        <Typography variant="body2" color="textSecondary" align="center" style={{ padding: 16 }}>
                          No se encontraron grupos
                        </Typography>
                      )}
                    </Box>
                  </Grid>

                  {/* ✅ FASE 2: CAMPOS GLOBALES - Programada y Lista de Archivos */}
                  <Grid xs={12} md={6} item>
                    <DateTimePickerWithTimezone
                      label={
                        <span>
                          <span role="img" aria-label="Fecha programada">📅</span> Programada
                        </span>
                      }
                      value={values.scheduledDate || null}
                      onChange={(newValue) => {
                        // ✅ OPCIÓN 1: Actualizar el campo inmediatamente sin validar (evita confusión mientras edita)
                        // La validación se hará en onBlur cuando el usuario termine de editar
                        setFieldValue('scheduledDate', newValue || "");
                      }}
                      onBlur={() => {
                        // ✅ OPCIÓN 1: Validar solo cuando el usuario termina de editar (onBlur)
                        // Esto evita validaciones confusas mientras el usuario está escribiendo
                        const currentValue = values.scheduledDate;
                        if (currentValue && currentValue !== "") {
                          const campaignTimezone = getCampaignTimezoneSync();
                          
                          // Parsear en zona empresa para validaciones
                          const selectedMoment = moment.tz(currentValue, 'YYYY-MM-DD HH:mm:ss', campaignTimezone);
                          const nowInCompanyTimezone = moment().tz(campaignTimezone);
                          const diffMinutes = selectedMoment.diff(nowInCompanyTimezone, 'minutes', true);
                          
                          // ✅ OPCIÓN 3: Mensaje más claro con ambas fechas visibles
                          if (diffMinutes < -1) {
                            // Fecha pasada - mostrar modal con mensaje mejorado
                            const pastDiffMinutes = nowInCompanyTimezone.diff(selectedMoment, 'minutes');
                            const formattedSelected = selectedMoment.format('DD/MM/YYYY HH:mm');
                            const formattedNow = nowInCompanyTimezone.format('DD/MM/YYYY HH:mm');
                            setDatePastMessage(
                              `La fecha seleccionada (${formattedSelected}) es anterior a la hora actual (${formattedNow}).\n\nDiferencia: ${pastDiffMinutes} minutos en el pasado.\n\n¿Desea actualizar la fecha a ahora mismo (hora actual + 2 minutos) para enviar la campaña inmediatamente?`
                            );
                            setPendingSetFieldValue(() => setFieldValue);
                            setDatePastModalOpen(true);
                          } else if (diffMinutes > 0 && diffMinutes < 10) {
                            // ✅ REGLA DE NEGOCIO: Fecha futura pero < 10 minutos - mostrar modal informativo
                            const formattedDate = selectedMoment.format('DD/MM/YYYY HH:mm');
                            setShortTimeMessage(
                              `La fecha programada (${formattedDate}) está a menos de 10 minutos (${Math.ceil(diffMinutes)} minutos). Si programa con menos de 10 minutos, no tendrá opción a modificar esta campaña ya que los tiempos son muy cortos para su procesamiento. Se sugiere programar envíos mayores a 30 minutos.`
                            );
                            setPendingSetFieldValue(() => setFieldValue);
                            setPendingScheduledAt(currentValue);
                            setShortTimeModalOpen(true);
                          }
                          
                          // ✅ Validar cambio de hora maestra cuando hay sub-tiempos (solo si cambió la hora)
                          if (values.scheduledDate && 
                              values.recurrenceHourlySchedules && 
                              values.recurrenceHourlySchedules.length > 0) {
                            const oldDate = new Date(values.scheduledDate);
                            const newDate = new Date(currentValue);
                            const oldHour = `${String(oldDate.getHours()).padStart(2, '0')}:${String(oldDate.getMinutes()).padStart(2, '0')}`;
                            const newHour = `${String(newDate.getHours()).padStart(2, '0')}:${String(newDate.getMinutes()).padStart(2, '0')}`;
                            if (oldHour !== newHour) {
                              setPendingScheduledDateChange(currentValue);
                              setPendingOldHour(oldHour);
                              setPendingNewHour(newHour);
                              setPendingSchedulesCount(values.recurrenceHourlySchedules.length);
                              setConfirmChangeScheduledDateModalOpen(true);
                            }
                          }
                        }
                      }}
                      timezone={getCampaignTimezoneSync()}
                      error={Boolean(touched.scheduledDate && errors.scheduledDate)}
                      helperText={touched.scheduledDate && errors.scheduledDate ? errors.scheduledDate : undefined}
                      disabled={isCompleted}
                      minDate={(() => {
                        // Calcular fecha mínima en zona empresa
                        const tz = getCampaignTimezoneSync();
                        const nowInCompanyTimezone = moment().tz(tz);
                        // Extraer valores para crear Date "falso"
                        const year = nowInCompanyTimezone.year();
                        const month = nowInCompanyTimezone.month();
                        const day = nowInCompanyTimezone.date();
                        const hour = nowInCompanyTimezone.hour();
                        const minute = nowInCompanyTimezone.minute();
                        return new Date(year, month, day, hour, minute);
                      })()}
                    />
                  </Grid>

                  <Grid xs={12} md={6} item>
                    <FormControl variant="outlined" margin="dense" className={`${classes.formControl} ${classes.selectField}`} fullWidth>
                      <InputLabel id="fileListId-selection-label"><span role="img" aria-label="Archivos">📁</span> Lista de Archivos</InputLabel>
                      <Field 
                        as={Select} 
                        name="fileListId" 
                        id="fileListId" 
                        labelId="fileListId-selection-label" 
                        defaultValue=""
                        value={values.fileListId || ""}
                        disabled={isCompleted || !!(attachment || campaignMedia)}
                      >
                        <MenuItem value=""><span role="img" aria-label="No definido">❌</span> No definido</MenuItem>
                        {files.map(f => (
                          <MenuItem key={f.id} value={f.id}>
                            <span role="img" aria-label="Archivo">📁</span> {f.name}
                          </MenuItem>
                        ))}
                      </Field>
                    </FormControl>
                  </Grid>

                  {/* ✅ FASE 2: PESTAÑAS PRINCIPALES */}
                  <Grid xs={12} item>
                    <Tabs
                      value={currentCampaignType === 'UNICA' ? Math.min(configTab, 1) : configTab}
                      indicatorColor="primary"
                      textColor="primary"
                      onChange={(e, v) => {
                        // ✅ CORRECCIÓN: Asegurar que para ÚNICA solo se permita 0 o 1
                        if (currentCampaignType === 'UNICA' && v > 1) {
                          setConfigTab(1);
                        } else {
                          setConfigTab(v);
                        }
                      }}
                      variant="fullWidth"
                      centered
                      style={{
                        borderRadius: 2,
                        marginBottom: 20,
                      }}
                    >
                      <Tab label={<><span role="img" aria-label="Mensaje">💬</span> MENSAJE</>} />
                      <Tab label={<><span role="img" aria-label="Intervalo">⏱️</span> INTERVALO</>} />
                      {currentCampaignType === 'RECURRENTE' && (
                        <Tab label={<><span role="img" aria-label="Recurrencia">🔄</span> RECURRENCIA</>} />
                      )}
                    </Tabs>
                  </Grid>

                  {/* ✅ FASE 2: CONTENIDO DE TABS - RECURRENCIA (solo para RECURRENTE) */}
                  {/* Nota: La sección completa de RECURRENCIA está más abajo (línea 2146) */}

                  {/* ✅ FASE 2: CONTENIDO DE TABS - MENSAJE */}
                  {((currentCampaignType === 'UNICA' && configTab === 0) || (currentCampaignType === 'RECURRENTE' && configTab === 0)) && (
                    <>
                      {/* ✅ Tabs de Mensajes - MSG 1-5 */}
                      <Grid xs={12} item>
                        <Tabs
                          value={messageTab}
                          indicatorColor="primary"
                          textColor="primary"
                          className={classes.tabmsg}
                          onChange={(e, v) => setMessageTab(v)}
                          variant="fullWidth"
                          centered
                        >
                          {[1, 2, 3, 4, 5].map((num) => (
                            <Tab key={num} label={`MSG. ${num}${values.useHourlySchedule && values.recurrenceType === "diaria" ? " (Maestro)" : ""}`} />
                          ))}
                        </Tabs>
                      </Grid>

                      {/* Área de texto del mensaje */}
                      <Grid xs={12} item>
                        <Field
                          as={TextField}
                          label={`Mensaje ${messageTab + 1}${values.useHourlySchedule && values.recurrenceType === "diaria" ? " (Mensaje Maestro - Primera ejecución del día)" : ""}`}
                          name={`message${messageTab + 1}`}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          multiline
                          rows={6}
                          className={classes.textField}
                          disabled={isCompleted}
                          error={Boolean(touched[`message${messageTab + 1}`] && errors[`message${messageTab + 1}`])}
                          helperText={
                            touched[`message${messageTab + 1}`] && errors[`message${messageTab + 1}`] 
                              ? errors[`message${messageTab + 1}`]
                              : values.useHourlySchedule && values.recurrenceType === "diaria" 
                                ? "Este mensaje se usará en la primera ejecución del día (hora programada principal)" 
                                : ""
                          }
                          inputProps={{
                            maxLength: 1000
                          }}
                        />
                        {/* ✅ Contador de caracteres y Botón ADJUNTAR ARCHIVO - Alineados como CampaignModal */}
                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center',
                          marginTop: 4,
                          marginBottom: 8
                        }}>
                          <Typography 
                            variant="caption" 
                            style={{ 
                              color: '#666'
                            }}
                          >
                            Máximo {(values[`message${messageTab + 1}`] || "").length}/1000 caracteres
                          </Typography>
                          {!isCompleted && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              {attachment || campaignMedia ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                  <AttachFileIcon style={{ color: '#666', fontSize: 20 }} />
                                  <Typography 
                                    variant="body2" 
                                    style={{ 
                                      color: '#666',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 4
                                    }}
                                  >
                                    <span style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      {attachment?.name || campaignMedia?.name}
                                    </span>
                                    <span style={{ color: '#999', fontSize: '0.875rem' }}>
                                      ({attachment ? formatFileSize(attachment.size) : (campaignMedia?.size ? formatFileSize(campaignMedia.size) : 'N/A')})
                                    </span>
                                  </Typography>
                                  <IconButton
                                    onClick={handleAttachmentClick}
                                    color="secondary"
                                    size="small"
                                    style={{ marginLeft: 4 }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              ) : (
                                <Button
                                  color="primary"
                                  onClick={handleAttachmentClick}
                                  disabled={!!values.fileListId}
                                  variant="outlined"
                                  startIcon={<AttachFileIcon />}
                                  size="small"
                                >
                                  Adjuntar Archivo
                                </Button>
                              )}
                              <input
                                ref={attachmentFile}
                                type="file"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                                accept="image/*,video/*,.pdf,.doc,.docx"
                                disabled={isCompleted || !!values.fileListId}
                              />
                            </div>
                          )}
                        </div>
                      </Grid>
                    </>
                  )}

                  {/* ✅ FASE 2: CONTENIDO DE TABS - INTERVALO */}
                  {((currentCampaignType === 'UNICA' && configTab === 1) || (currentCampaignType === 'RECURRENTE' && configTab === 1)) && (
                    <IntervalTab
                      type="groups"
                      totalItems={selectedGroups.length}
                      itemListName={null}
                      values={values}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      disabled={isCompleted}
                      classes={classes}
                    />
                  )}

                  {/* ✅ FASE 2: CONTENIDO DE TABS - RECURRENCIA (solo para RECURRENTE) */}
                  {currentCampaignType === 'RECURRENTE' && configTab === 2 && (
                    <Grid xs={12} item>
                          {/* ✅ Selector de Tipo de Recurrencia - Directo, sin títulos ni switches redundantes */}
                          <Grid spacing={2} container>
                            <Grid xs={12} md={6} item>
                              <FormControl 
                                variant="outlined" 
                                fullWidth 
                                margin="dense"
                                className={`${classes.formControl} ${classes.selectField}`}
                              >
                                <InputLabel id="recurrenceType-selection-label">
                                  Tipo de Recurrencia
                                </InputLabel>
                                <Select
                                  name="recurrenceType"
                                  label="Tipo de Recurrencia"
                                  labelId="recurrenceType-selection-label"
                                  id="recurrenceType"
                                  value={values.recurrenceType || ""}
                                  disabled={isCompleted}
                                  error={Boolean(touched.recurrenceType && errors.recurrenceType)}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    handleRecurrenceTypeChange(newValue, values.recurrenceType, setFieldValue, values);
                                  }}
                                >
                                  <MenuItem value="">Seleccione el tipo de recurrencia</MenuItem>
                                  <MenuItem value="diaria">Diaria</MenuItem>
                                  <MenuItem value="semanal">Semanal</MenuItem>
                                  <MenuItem value="quincenal">Quincenal</MenuItem>
                                  <MenuItem value="mensual">Mensual</MenuItem>
                                  <MenuItem value="anual">Anual</MenuItem>
                                </Select>
                                {touched.recurrenceType && errors.recurrenceType ? (
                                  <Typography variant="caption" color="error" style={{ marginLeft: '14px', marginTop: '3px' }}>
                                    {errors.recurrenceType}
                                  </Typography>
                                ) : (
                                  <Typography variant="caption" color="textSecondary" style={{ marginLeft: '14px', marginTop: '3px' }}>
                                    Seleccione el tipo de recurrencia
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>
                          </Grid>

                          {/* ✅ LÓGICA ESPECÍFICA DE GROUP CAMPAIGNS: "Diaria" con horarios múltiples */}
                          {values.recurrenceType === "diaria" && (
                            <Grid spacing={2} container style={{ marginTop: '8px' }}>
                              {/* ✅ Toggle "Enviar por horas múltiples" - Solo para recurrencia diaria */}
                              <Grid xs={12} item>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={values.useHourlySchedule || false}
                                      onChange={(e) => {
                                        const newValue = e.target.checked;
                                        
                                        // ✅ NUEVO (09/12/2025): Si se está DESHABILITANDO y hay horarios configurados
                                        if (!newValue && 
                                            values.recurrenceHourlySchedules && 
                                            values.recurrenceHourlySchedules.length > 0) {
                                          // Mostrar modal de confirmación
                                          setPendingSchedulesCount(values.recurrenceHourlySchedules.length);
                                          setConfirmDisableHourlyScheduleModalOpen(true);
                                        } else {
                                          // Si se está habilitando o no hay horarios, aplicar directamente
                                          setFieldValue('useHourlySchedule', newValue);
                                          // ✅ NUEVO (09/12/2025): Si se activa useHourlySchedule y es "diaria", establecer recurrenceInterval = 1
                                          if (newValue && values.recurrenceType === "diaria") {
                                            if (!values.recurrenceInterval || values.recurrenceInterval === "" || values.recurrenceInterval < 1) {
                                              setFieldValue('recurrenceInterval', 1);
                                            }
                                          }
                                          if (!newValue) {
                                            setFieldValue('recurrenceHourlySchedules', []);
                                          }
                                        }
                                      }}
                                      disabled={isCompleted}
                                      color="primary"
                                    />
                                  }
                                  label={
                                    <Box>
                                      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                                        <span role="img" aria-label="reloj">🕐</span> Enviar por horas múltiples
                                      </Typography>
                                      <Typography variant="caption" color="textSecondary">
                                        Configure diferentes mensajes para diferentes horarios del día (ejecuciones subsecuentes). 
                                        Los mensajes maestros (MSG 1-5) siempre se usan en la primera ejecución del día.
                                      </Typography>
                                    </Box>
                                  }
                                />
                              </Grid>

                              {/* ✅ NUEVA SECCIÓN: Horarios de Envío (08/12/2025) - Solo si useHourlySchedule = true y recurrenceType = "diaria" */}
                              {values.useHourlySchedule && values.recurrenceType === "diaria" && (
                                <Grid xs={12} item style={{ marginTop: '16px' }}>
                                  <Divider style={{ margin: '20px 0' }} />
                                  <Typography variant="h6" style={{ marginBottom: '16px', color: theme.mode === 'dark' ? theme.palette.text.primary : '#333' }}>
                                    <span role="img" aria-label="reloj">🕐</span> Horarios de Envío
                                  </Typography>
                                  <Typography variant="body2" style={{ marginBottom: '16px', color: theme.mode === 'dark' ? theme.palette.text.secondary : '#666' }}>
                                    Configure diferentes mensajes para diferentes horarios del día (ejecuciones subsecuentes después de la primera). 
                                    Los horarios se ordenarán automáticamente de forma cronológica. 
                                    <strong style={{ color: theme.mode === 'dark' ? '#fbbf24' : '#d97706' }}> Nota:</strong> La primera ejecución del día (hora programada principal) usa los mensajes maestros (MSG 1-5) configurados arriba.
                                  </Typography>
                                  
                                  {/* Lista de horarios configurados */}
                                  <Box style={{ marginBottom: '16px' }}>
                                    {values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length > 0 ? (
                                      <List>
                                        {values.recurrenceHourlySchedules
                                          .sort((a, b) => a.time.localeCompare(b.time))
                                          .map((schedule, index) => (
                                            <ListItem 
                                              key={index} 
                                              style={{ 
                                                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#ddd'}`, 
                                                borderRadius: '8px', 
                                                marginBottom: '8px', 
                                                backgroundColor: theme.mode === 'dark' ? '#374151' : '#f9f9f9' 
                                              }}
                                            >
                                              <ListItemText
                                                primary={
                                                  <Box display="flex" alignItems="center" justifyContent="space-between">
                                                    <Typography variant="body1" style={{ fontWeight: 'bold', color: theme.mode === 'dark' ? theme.palette.text.primary : '#333' }}>
                                                      <span role="img" aria-label="reloj">🕐</span> {schedule.time}
                                                    </Typography>
                                                    <Box display="flex" gap={1}>
                                                      <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => handleOpenHourlyScheduleModal(index)}
                                                        disabled={isCompleted}
                                                      >
                                                        Editar
                                                      </Button>
                                                      <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={() => {
                                                          const newSchedules = values.recurrenceHourlySchedules.filter((_, i) => i !== index);
                                                          setFieldValue('recurrenceHourlySchedules', newSchedules);
                                                        }}
                                                        disabled={isCompleted}
                                                      >
                                                        Eliminar
                                                      </Button>
                                                    </Box>
                                                  </Box>
                                                }
                                                secondary={
                                                  <Typography variant="body2" style={{ marginTop: '4px', color: theme.mode === 'dark' ? theme.palette.text.secondary : '#666' }}>
                                                    {schedule.message1 ? `Mensaje: ${schedule.message1.substring(0, 50)}${schedule.message1.length > 50 ? '...' : ''}` : 'Sin mensaje'}
                                                    {schedule.mediaName && ` | Archivo: ${schedule.mediaName}`}
                                                  </Typography>
                                                }
                                              />
                                            </ListItem>
                                          ))}
                                      </List>
                                    ) : (
                                      <Typography variant="body2" style={{ textAlign: 'center', padding: '16px', color: theme.mode === 'dark' ? theme.palette.text.secondary : '#666' }}>
                                        No hay horarios configurados. Agregue al menos un horario para continuar.
                                      </Typography>
                                    )}
                                  </Box>
                                  
                                  {/* Botones para agregar/eliminar horarios */}
                                  <Box display="flex" gap={1} style={{ marginTop: '8px' }}>
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      onClick={() => handleOpenHourlyScheduleModal(null)}
                                      disabled={isCompleted || (values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length >= 24)}
                                    >
                                      <span role="img" aria-label="agregar">➕</span> Agregar Horario
                                    </Button>
                                    {/* ✅ NUEVO (09/12/2025): Botón "Eliminar todos" */}
                                    {values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length > 0 && (
                                      <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => {
                                          setConfirmDeleteAllSchedulesModalOpen(true);
                                        }}
                                        disabled={isCompleted}
                                      >
                                        <span role="img" aria-label="eliminar">🗑️</span> Eliminar Todos
                                      </Button>
                                    )}
                                  </Box>
                                  {values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length >= 24 && (
                                    <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
                                      Máximo 24 horarios por día
                                    </Typography>
                                  )}
                                </Grid>
                              )}
                              
                              {/* Intervalo - Ocultar si useHourlySchedule = true */}
                              {values.recurrenceType === "diaria" && !(values.useHourlySchedule && values.recurrenceType === "diaria") && (
                                <Grid spacing={2} container style={{ marginTop: '8px' }}>
                                  <Grid xs={12} md={6} item>
                                    <TextField
                                      label="Intervalo"
                                      name="recurrenceInterval"
                                      type="number"
                                      value={values.recurrenceInterval === undefined || values.recurrenceInterval === null || values.recurrenceInterval === "" ? 1 : values.recurrenceInterval}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === "" || val === null || val === undefined) {
                                          setFieldValue('recurrenceInterval', "");
                                        } else {
                                          const numVal = parseInt(val, 10);
                                          setFieldValue('recurrenceInterval', isNaN(numVal) ? "" : numVal);
                                        }
                                      }}
                                      disabled={isCompleted}
                                      helperText="Ejemplo: 1 = cada día, 2 = cada 2 días"
                                      inputProps={{ min: 1, step: 1 }}
                                      error={Boolean(touched.recurrenceInterval && errors.recurrenceInterval)}
                                      variant="outlined"
                                      margin="dense"
                                      fullWidth
                                      className={classes.textField}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          )}

                          {/* ✅ USAR RecurrenceTab COMPARTIDO para Semanal/Mensual/Anual/Quincenal */}
                          {values.recurrenceType && values.recurrenceType !== "" && values.recurrenceType !== "diaria" && (
                            <RecurrenceTab
                              values={values}
                              setFieldValue={setFieldValue}
                              touched={touched}
                              errors={errors}
                              disabled={isCompleted}
                              classes={classes}
                            />
                          )}
                    </Grid>
                  )}
                  </Grid>
                </DialogContent>

                <DialogActions className={classes.dialogActions}>
                <Button
                  onClick={handleClose}
                  className={classes.secondaryButton}
                  variant="outlined"
                >
                  Cerrar
                </Button>
                <div className={classes.buttonProgress}>
                  {loading && <CircularProgress size={24} />}
                </div>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading || isSubmitting || isCompleted} // ✅ Deshabilitar si ya fue completada
                  className={classes.primaryButton}
                >
                    {campaignId ? "Actualizar" : "ENVIAR CAMPAÑA"}
                  </Button>
                </DialogActions>
              </Form>
              
              {/* ✅ NUEVO (08/12/2025): Modal para agregar/editar horario */}
              <Dialog 
        open={hourlyScheduleModalOpen} 
        onClose={handleCloseHourlyScheduleModal} 
        fullWidth 
        maxWidth="md"
      >
        <DialogTitle>
          {editingScheduleIndex !== null ? "Editar Horario" : "Agregar Horario"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ marginTop: '8px' }}>
            {/* Hora - Usar input type="time" para mejor UX */}
            <Grid xs={12} md={6} item>
              {(() => {
                // ✅ NUEVO (09/12/2025): Calcular hora mínima permitida y helper text
                const minHourInfo = getMinimumAllowedHour();
                const minHour = minHourInfo ? minHourInfo.hour : null;
                const context = minHourInfo ? minHourInfo.context : null;
                
                // ✅ NUEVO (09/12/2025): Validación en tiempo real - Solo mostrar error si el usuario modificó el campo
                let errorMessage = null;
                // ✅ Solo validar si el campo fue modificado por el usuario
                if (hourlyScheduleTimeTouched && currentSchedule.time && values.scheduledDate) {
                  try {
                    const scheduledDateObj = new Date(values.scheduledDate);
                    const scheduledHour = `${String(scheduledDateObj.getHours()).padStart(2, '0')}:${String(scheduledDateObj.getMinutes()).padStart(2, '0')}`;
                    
                    if (currentSchedule.time === scheduledHour) {
                      errorMessage = `No puede coincidir con la hora programada principal (${scheduledHour})`;
                    } else if (minHour && currentSchedule.time < minHour) {
                      errorMessage = `La hora debe ser posterior a ${minHour}`;
                    }
                  } catch (error) {
                    console.warn("Error validando hora:", error);
                  }
                }
                
                return (
                  <TextField
                    label="Hora (HH:mm)"
                    type="time"
                    value={currentSchedule.time || ""}
                    onChange={(e) => {
                      const timeValue = e.target.value;
                      // ✅ Marcar como "touched" cuando el usuario modifica el campo
                      if (!hourlyScheduleTimeTouched) {
                        setHourlyScheduleTimeTouched(true);
                      }
                      // ✅ NUEVO (09/12/2025): Validación en tiempo real
                      if (timeValue && values.scheduledDate) {
                        try {
                          const scheduledDateObj = new Date(values.scheduledDate);
                          const scheduledHour = `${String(scheduledDateObj.getHours()).padStart(2, '0')}:${String(scheduledDateObj.getMinutes()).padStart(2, '0')}`;
                          
                          if (timeValue === scheduledHour) {
                            toast.error(`No puede coincidir con la hora programada principal (${scheduledHour})`);
                            return;
                          }
                          
                          if (minHour && timeValue < minHour) {
                            toast.error(`La hora debe ser posterior a ${minHour}`);
                            return;
                          }
                        } catch (error) {
                          console.warn("Error validando hora:", error);
                        }
                      }
                      
                      // Si el usuario escribe manualmente, formatear a HH:mm
                      if (timeValue) {
                        setCurrentSchedule({ ...currentSchedule, time: timeValue });
                      } else {
                        setCurrentSchedule({ ...currentSchedule, time: "" });
                      }
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      errorMessage 
                        ? errorMessage 
                        : minHour 
                          ? `Hora mínima permitida: ${minHour} (${context})` 
                          : "Seleccione la hora o escriba en formato HH:mm (ej: 09:30, 14:15)"
                    }
                    error={!!errorMessage}
                    inputProps={{ 
                      step: 300, // Intervalos de 5 minutos
                      min: minHour || undefined // ✅ NUEVO (09/12/2025): Establecer hora mínima si está disponible
                    }}
                  />
                );
              })()}
            </Grid>
            
            {/* Tabs de Mensajes */}
            <Grid xs={12} item>
              <Tabs
                value={hourlyScheduleMessageTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(e, v) => setHourlyScheduleMessageTab(v)}
                variant="fullWidth"
                centered
              >
                {[1, 2, 3, 4, 5].map((num) => (
                  <Tab key={num} label={`MSG. ${num}`} />
                ))}
              </Tabs>
            </Grid>
            
            {/* Área de texto del mensaje */}
            <Grid xs={12} item>
              <TextField
                label={`Mensaje ${hourlyScheduleMessageTab + 1}${hourlyScheduleMessageTab === 0 ? ' (Obligatorio)' : ''}`}
                value={currentSchedule[`message${hourlyScheduleMessageTab + 1}`] || ""}
                onChange={(e) => setCurrentSchedule({ ...currentSchedule, [`message${hourlyScheduleMessageTab + 1}`]: e.target.value })}
                variant="outlined"
                margin="dense"
                fullWidth
                multiline
                rows={6}
                required={hourlyScheduleMessageTab === 0}
              />
            </Grid>
            
            {/* ✅ Archivo adjunto (opcional) - Replicando lógica de MENSAJE */}
            <Grid xs={12} item>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {currentSchedule.mediaName ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <AttachFileIcon style={{ color: '#666', fontSize: 20 }} />
                    <Typography 
                      variant="body2" 
                      style={{ 
                        color: '#666',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4
                      }}
                    >
                      <span style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {currentSchedule.mediaName}
                      </span>
                      <span style={{ color: '#999', fontSize: '0.875rem' }}>
                        {currentSchedule.mediaFile ? `(${formatFileSize(currentSchedule.mediaFile.size)})` : ''}
                      </span>
                    </Typography>
                    <IconButton
                      onClick={() => {
                        setCurrentSchedule({
                          ...currentSchedule,
                          mediaName: null,
                          mediaPath: null,
                          mediaFile: null
                        });
                        if (hourlyScheduleFileInput.current) {
                          hourlyScheduleFileInput.current.value = '';
                        }
                        toast.info("Archivo eliminado");
                      }}
                      color="secondary"
                      size="small"
                      style={{ marginLeft: 4 }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                ) : (
                  <Button
                    color="primary"
                    onClick={() => {
                      if (hourlyScheduleFileInput.current) {
                        hourlyScheduleFileInput.current.click();
                      }
                    }}
                    variant="outlined"
                    startIcon={<AttachFileIcon />}
                    size="small"
                  >
                    Adjuntar Archivo
                  </Button>
                )}
                <input
                  ref={hourlyScheduleFileInput}
                  type="file"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setCurrentSchedule({
                        ...currentSchedule,
                        mediaName: file.name,
                        mediaFile: file, // Guardar el archivo completo para obtener el tamaño
                        mediaPath: null // Se subirá al guardar la campaña
                      });
                      toast.success(`Archivo seleccionado: ${file.name}`);
                    }
                  }}
                  accept="image/*,video/*,.pdf,.doc,.docx"
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHourlyScheduleModal} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveHourlySchedule} color="primary" variant="contained">
            {editingScheduleIndex !== null ? "Actualizar" : "Agregar"}
                </Button>
              </DialogActions>
            </Dialog>
              </>
            );
          }}
        </Formik>
      </Dialog>

      <ConfirmationModal
        title="Envío Inmediato"
        open={confirmModalOpen}
        onClose={() => {
          // ✅ Importante: Resetear setSubmitting cuando se cancela
          if (pendingSubmit?.setSubmitting) {
            pendingSubmit.setSubmitting(false);
          }
          setConfirmModalOpen(false);
          setPendingSubmit(null);
        }}
        onConfirm={handleConfirmAndSave}
      >
        <Box>
          No hay fecha programada configurada.
          <br />
          <br />
          La campaña se enviará <strong>INMEDIATAMENTE</strong> a todos los grupos seleccionados.
          <br />
          <br />
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (10/12/2025): Modal de error cuando falta scheduledDate para agregar horarios */}
      <ConfirmationModal
        title="⚠️ Fecha Programada Requerida"
        open={missingScheduledDateModalOpen}
        onClose={() => setMissingScheduledDateModalOpen(false)}
        onConfirm={() => setMissingScheduledDateModalOpen(false)}
        confirmText="Entendido"
        showCancel={false}
      >
        <Box>
          Para agregar horarios de envío, primero debe configurar la <strong>Fecha y Hora Programada</strong> (hora maestra).
          <br />
          <br />
          Los horarios de envío son ejecuciones subsecuentes que ocurren <strong>después</strong> de la primera ejecución del día.
          <br />
          <br />
          Por favor, configure la fecha y hora programada antes de agregar horarios.
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de confirmación para cambio de hora maestra */}
      <ConfirmationModal
        title="⚠️ Cambio de Hora Programada Principal"
        open={confirmChangeScheduledDateModalOpen}
        onClose={() => {
          setConfirmChangeScheduledDateModalOpen(false);
          setPendingScheduledDateChange(null);
          setPendingOldHour(null);
          setPendingNewHour(null);
          setPendingSchedulesCount(0);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current && pendingScheduledDateChange) {
            formikSetFieldValueRef.current('scheduledDate', pendingScheduledDateChange);
            formikSetFieldValueRef.current('recurrenceHourlySchedules', []);
            toast.success("Se eliminaron los horarios subsecuentes debido al cambio de hora principal");
            setPendingScheduledDateChange(null);
            setPendingOldHour(null);
            setPendingNewHour(null);
            setPendingSchedulesCount(0);
          }
          setConfirmChangeScheduledDateModalOpen(false);
        }}
        confirmText="Continuar"
        cancelText="Cancelar"
      >
        <Box>
          Ya hay {pendingSchedulesCount > 0 ? pendingSchedulesCount : ''} horarios configurados para esta campaña.
          <br />
          <br />
          {pendingOldHour && pendingNewHour && (
            <>
              Si cambia la hora programada principal de <strong>{pendingOldHour}</strong> a <strong>{pendingNewHour}</strong>, 
              todos los horarios subsecuentes existentes serán eliminados para evitar conflictos.
              <br />
              <br />
            </>
          )}
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de confirmación para eliminar todos los horarios */}
      <ConfirmationModal
        title="Eliminar Todos los Horarios"
        open={confirmDeleteAllSchedulesModalOpen}
        onClose={() => {
          setConfirmDeleteAllSchedulesModalOpen(false);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current) {
            formikSetFieldValueRef.current('recurrenceHourlySchedules', []);
            toast.success("Todos los horarios fueron eliminados");
          }
          setConfirmDeleteAllSchedulesModalOpen(false);
        }}
        confirmText="Eliminar"
        cancelText="Cancelar"
      >
        <Box>
          ¿Eliminar todos los horarios configurados?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de confirmación para desactivar useHourlySchedule */}
      <ConfirmationModal
        title="⚠️ Desactivar Envío por Horas Múltiples"
        open={confirmDisableHourlyScheduleModalOpen}
        onClose={() => {
          setConfirmDisableHourlyScheduleModalOpen(false);
          setPendingSchedulesCount(0);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current) {
            formikSetFieldValueRef.current('useHourlySchedule', false);
            formikSetFieldValueRef.current('recurrenceHourlySchedules', []);
            toast.success("La opción 'Enviar por horas múltiples' fue desactivada y los horarios fueron eliminados");
            setPendingSchedulesCount(0);
          }
          setConfirmDisableHourlyScheduleModalOpen(false);
        }}
        confirmText="Continuar"
        cancelText="Cancelar"
      >
        <Box>
          Ya hay {pendingSchedulesCount > 0 ? pendingSchedulesCount : ''} horarios configurados para esta campaña.
          <br />
          <br />
          Si desactiva esta opción, todos los horarios subsecuentes existentes serán eliminados.
          <br />
          <br />
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de Confirmación para cambio de Tipo de Recurrencia */}
      <ConfirmationModal
        title="⚠️ Cambio de Tipo de Recurrencia"
        open={confirmChangeRecurrenceTypeModalOpen}
        onClose={() => {
          setConfirmChangeRecurrenceTypeModalOpen(false);
          setPendingRecurrenceTypeChange(null);
          setPendingOldRecurrenceType(null);
          setPendingNewRecurrenceType(null);
          setPendingSchedulesCount(0);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current && pendingRecurrenceTypeChange !== null) {
            handleConfirmChangeRecurrenceType(formikSetFieldValueRef.current);
          }
        }}
        confirmText="Continuar"
        cancelText="Cancelar"
      >
        <Box>
          Ya hay {pendingSchedulesCount} horarios configurados (solo válidos para recurrencia diaria).
          <br /><br />
          Si cambia el tipo de recurrencia de <strong>"{pendingOldRecurrenceType}"</strong> a <strong>"{pendingNewRecurrenceType}"</strong>, 
          todos los horarios subsecuentes existentes serán eliminados y la opción "Enviar por horas múltiples" será desactivada automáticamente.
          <br /><br />
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de Confirmación para deshabilitar Recurrencia */}
      <ConfirmationModal
        title="⚠️ Desactivar Recurrencia"
        open={confirmDisableRecurrenceModalOpen}
        onClose={() => {
          setConfirmDisableRecurrenceModalOpen(false);
          setPendingSchedulesCount(0);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current) {
            handleConfirmDisableRecurrence(formikSetFieldValueRef.current);
          }
        }}
        confirmText="Continuar"
        cancelText="Cancelar"
      >
        <Box>
          Ya hay {pendingSchedulesCount} horarios de envío configurados.
          <br /><br />
          Si desactiva la recurrencia, todos los horarios subsecuentes existentes serán eliminados junto con la configuración de recurrencia.
          <br /><br />
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ FASE 2: Modales de validación de fecha */}
      <Dialog
        open={datePastModalOpen}
        onClose={() => {
          setDatePastModalOpen(false);
          setPendingSetFieldValue(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Fecha pasada">📅</span> Fecha en el pasado
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{datePastMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setDatePastModalOpen(false);
              setPendingSetFieldValue(null);
            }} 
            color="default"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button 
            onClick={() => {
              // ✅ ACEPTAR: Actualizar fecha a hora actual + 2 minutos
              const timezone = getCampaignTimezoneSync();
              const nowInCompanyTimezone = moment().tz(timezone);
              // Calcular hora actual + 2 minutos
              const newScheduledDate = nowInCompanyTimezone.add(2, 'minutes').format('YYYY-MM-DD HH:mm:ss');
              
              if (pendingSetFieldValue) {
                // Actualizar el campo en el formulario
                pendingSetFieldValue('scheduledDate', newScheduledDate);
              }
              
              // Si hay valores pendientes de guardado, actualizar scheduledDate y continuar
              if (pendingSaveValues && saveCampaignRef.current) {
                const updatedValues = { ...pendingSaveValues, scheduledDate: newScheduledDate };
                setPendingSaveValues(null);
                setDatePastModalOpen(false);
                setPendingSetFieldValue(null);
                // Continuar con el guardado (saltando validación de fecha pasada y tiempo corto)
                setTimeout(() => {
                  saveCampaignRef.current(updatedValues, true, true);
                }, 100);
              } else {
                setDatePastModalOpen(false);
                setPendingSetFieldValue(null);
                setPendingSaveValues(null);
              }
            }} 
            color="primary" 
            variant="contained"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={shortTimeModalOpen}
        onClose={() => {
          setShortTimeModalOpen(false);
          setShortTimeMessage("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Tiempo corto">⏰</span> Tiempo de programación muy corto
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{shortTimeMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              // ✅ CANCELAR: Cerrar modal sin hacer nada
              setShortTimeModalOpen(false);
              setShortTimeMessage("");
              setPendingScheduledAt(null);
            }} 
            color="default"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button 
            onClick={async () => {
              // ✅ ENTENDIDO: Aceptar la hora seleccionada y continuar
              const pendingSetFieldValueFn = pendingSetFieldValue;
              const scheduledDateValue = pendingScheduledAt;
              const pendingValues = pendingSaveValues;
              const saveFn = saveCampaignRef.current;
              
              // Cerrar modal
              setShortTimeModalOpen(false);
              setShortTimeMessage("");
              
              // Si viene desde onChange del campo, actualizar el campo
              if (pendingSetFieldValueFn && scheduledDateValue) {
                pendingSetFieldValueFn('scheduledDate', scheduledDateValue);
              }
              
              // Si viene desde processSave (botón AGREGAR), continuar con el guardado
              if (saveFn && pendingValues) {
                // Continuar con el guardado saltando la validación de tiempo corto
                setTimeout(() => {
                  saveFn(pendingValues, false, true); // shouldSkipShortTimeCheck = true
                }, 100);
              }
              
              // Limpiar valores pendientes
              setPendingScheduledAt(null);
            }} 
            color="primary" 
            variant="contained"
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={formatInvalidModalOpen}
        onClose={() => setFormatInvalidModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Formato inválido">⚠️</span> Formato de archivo no permitido
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{formatInvalidMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFormatInvalidModalOpen(false)} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={sizeExceededModalOpen}
        onClose={() => setSizeExceededModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Tamaño excedido">⚠️</span> Tamaño de archivo excedido
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>
            El archivo seleccionado excede el tamaño máximo permitido. Por favor, seleccione un archivo más pequeño.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSizeExceededModalOpen(false)} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GroupCampaignModal;
